import { Link } from "@/lib/router-compat";
import { COMPANY } from "@/lib/seo";

/**
 * Rail contact card — dark panel with the phone number set large in
 * Barlow Condensed, hours line, and the estimate CTA.
 */
const RailContactCard = ({ dataCta = "rail-phone", ctaLabel = "Request an Estimate" }: { dataCta?: string; ctaLabel?: string }) => (
  <div className="rounded-[4px] bg-charcoal p-5 text-charcoal-foreground">
    <a
      href={`tel:${COMPANY.phoneTel}`}
      data-cta={dataCta}
      className="block font-condensed text-[32px] font-bold leading-none text-white hover:text-primary-light"
    >
      {COMPANY.phone}
    </a>
    <p className="mt-3 font-body text-[13px] leading-relaxed text-charcoal-foreground/70">
      Mon–Fri 8:00–4:30 · 24/7 Emergency
    </p>
    <Link
      to="/request-estimate"
      className="mt-4 inline-flex w-full items-center justify-center rounded-[4px] bg-primary px-4 py-2.5 font-heading text-sm font-bold text-primary-foreground hover:bg-primary/90"
    >
      {ctaLabel}
    </Link>
  </div>
);

export default RailContactCard;
